<template>
  <div>
    <protocol-header v-if="protocol && !hideHeaders"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <amendment-header v-if="amendment && !hideHeaders"
                      :amendment="amendment"></amendment-header>
    
    <div class="row">
      <div class="col-12">
        <div class="card-header">
          <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
        </div>
        
        <div class="card">
          <div class="card-body">
            <div class="nav-scroller border-bottom">
              <div class="nav nav-tabs">
                <a class="nav-link active" href="#amendment-data" data-toggle="tab">Datos de enmienda</a>
                <a :href="`/protocolo/${protocol.id}/consultar`"
                   class="nav-link">
                  Consultar protocolo</a>
                <a class="nav-link" href="#attachments" data-toggle="tab">Incorporar anexos a la solicitud</a>
              </div>
            </div>
            
            <div class="tab-content pt-4">
              <div class="tab-pane fade show active" id="amendment-data" role="tabpanel">
                <form method="post" onsubmit="return false" ref="form"
                      v-if="amendment">
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="justification">Explique en que consiste la enmienda al protocolo:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <textarea name="justification"
                              id="justification"
                              placeholder="¿En qué consiste la enmienda al protocolo?"
                              class="form-control"
                              rows="5"
                              cols="5"
                              v-model="amendment.justification"></textarea>
                  </div>
                  
                  <div class="form-group">
                    <label class="d-block font-weight-normal">¿La enmienda requiere modificaciones al protocolo?
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <div class="form-row">
                      <div class="col d-flex">
                        <div class="custom-control custom-radio mr-3 d-flex align-items-center">
                          <input type="radio"
                                 class="custom-control-input"
                                 name="requires_changes"
                                 id="requires_changes_yes"
                                 :value="true"
                                 v-model="amendment.requires_changes">
                          <label class="custom-control-label" for="requires_changes_yes">Si</label>
                        </div>
                        <div class="custom-control custom-radio d-flex align-items-center">
                          <input type="radio"
                                 class="custom-control-input"
                                 name="requires_changes"
                                 id="requires_changes_no"
                                 :value="false"
                                 v-model="amendment.requires_changes">
                          <label class="custom-control-label" for="requires_changes_no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-group" v-if="amendment.requires_changes && !readonly">
                    <p class="alert alert-danger font-weight-bold text-black">
                      Deberá subir a continuación el documento modificado resaltando los cambios realizados.
                      <span class="text-danger">ESTÁ SECCIÓN ES EXCLUSIVAMENTE PARA PROTOCOLO, CUALQUIER OTRO DOCUMENTO INCORPORARLO COMO ANEXO.</span>
                    </p>
                    
                    <label for="protocol_file">Protocolo de texto completo:</label>
                    <div class="custom-file">
                      <input type="file"
                             class="custom-file-input"
                             id="protocol_file"
                             name="protocol_file"
                             accept="application/pdf"
                             ref="protocol_file"
                             @change="e => this.file = e.target.files[0]">
                      
                      <label class="custom-file-label" for="protocol_file">
                        Seleccionar archivo</label>
                    </div>
                  </div>
  
                  <div class="mt-4 form-group" v-if="selectedAmendment && selectedAmendment.file_path">
                    <p class="font-weight-bold">Archivo seleccionado:</p>
                    <div class="list-group list-group-bordered">
                      <div class="list-group-item">
                        <div class="list-group-item-figure">
                          <a :href="`/${selectedAmendment.file_path}`" target="_blank"  :download="selectedAmendment.file_name" class="tile tile-circle bg-red"><i class="fas fa-file-pdf"></i></a>
                        </div>
                        <div class="list-group-item-body">
                          <a :href="`/${selectedAmendment.file_path}`" target="_blank"  :download="selectedAmendment.file_name">{{ selectedAmendment.file_name }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="d-flex" v-if="!readonly">
                    <button type="button"
                            class="btn btn-primary btn-lg mr-3"
                            @click.prevent="saveAmendment"
                            :disabled="saving">
                      <spinner small class="text-white" v-if="saving"></spinner>
                      {{ amendment ? 'Actualizar' : 'Guardar' }}
                    </button>
                    
                    <button type="button"
                            class="btn btn-dark btn-lg"
                            v-if="amendment.updated"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#send-amendment-modal">
                      <i class="fas fa-paper-plane mr-2"></i> Enviar enmienda a revisión
                    </button>
                    
                    <button type="button"
                            class="btn btn-danger btn-lg ml-auto"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#delete-amendment-modal">Eliminar
                    </button>
                  </div>
                </form>
              </div>
  
              <div class="tab-pane fade" id="attachments" role="tabpanel">
                <div class="page-section">
                  <div class="section-block m-0 p-0">
                    <div class="row">
                      <div class="col">
                        <p class="font-weight-bold mt-3"
                           v-if="amendment && amendment.attachments && amendment.attachments.length">
                          Anexos agregados
                        </p>
                        
                        <files-list v-if="selectedAmendment"
                                    :model="selectedAmendment"
                                    :files="selectedAmendment.attachments"
                                    :save-files-function="saveAttachments"
                                    @delete-file="deleteAttachment"
                                    :readonly="readonlyFiles"></files-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <portal to="task-modals">
        <ok-cancel-dialog title="Requiere cambios"
                          id="amendment-require-changes-modal"
                          ref="amendment-require-changes-modal"
                          content="<p>¿La enmienda requiere modificaciones al protocolo?</p>"
                          ok-button-text="Si"
                          cancel-button-text="No"
                          :ok-callback="() => this.requiresChanges = true"
                          @cancel-button-pressed="requiresChanges = false"></ok-cancel-dialog>
        
        <ok-cancel-dialog title="Eliminar enmienda"
                          id="delete-amendment-modal"
                          ref="delete-amendment-modal"
                          content="<p>¿Esta seguro eliminar la enmienda?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="deleteAmendment"></ok-cancel-dialog>
        
        <ok-cancel-dialog title="Enviar enmienda a revisión"
                          id="send-amendment-modal"
                          ref="send-amendment-modal"
                          content="<p>¿Esta seguro de enviar la enmienda a revisón?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="sendAmendmentToEvaluation"></ok-cancel-dialog>
        
        <file-modal id="file-modal"
                    multiple
                    title="Adjuntar anexos"
                    :save-files-function="saveAttachments"></file-modal>
      </portal>
    </div>
  </div>
</template>
<script>
  import autosize from 'autosize'
  import 'jquery-validation'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import Spinner from '../ui/Spinner'
  import ProtocolHeader from '../protocols/ProtocolHeader'
  import AmendmentHeader from './AmendmentHeader'
  import FileModal from '../ui/FileModal'
  import FilesList from '../protocols/FilesList'
  
  export default {
    name: 'AmendmentProtocol',
    components: {
      OkCancelDialog,
      ProtocolHeader,
      AmendmentHeader,
      Spinner,
      FileModal,
      FilesList,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
      amendment: Object,
      committee: Object,
      readonly: {
        type: Boolean,
        default: false,
      },
      readonlyFiles: {
        type: Boolean,
        default: false,
      },
      hideHeaders: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editing: false,
        saving: false,
        requiresChanges: null,
        type: 'protocol',
        file: null,
      }
    },
    methods: {
      ...mapActions({
        saveProtocolAmendment: 'amendments/saveAmendment',
        saveAmendmentAttachments: 'amendments/saveAttachments',
        deleteProtocolAmendment: 'amendments/deleteAmendment',
        removeAttachmentFromAmendment: 'amendments/removeAmendmentAttachment',
        sendAmendment: 'amendments/sendAmendmentToEvaluation',
      }),
      
      ...mapMutations({
        setAmendment: 'amendments/SET_AMENDMENT',
      }),
      
      saveAmendment: async function() {
        if(!$(this.$refs.form).valid()) {
          return false
        }
        
        this.saving = true
        
        const formData = new FormData()
        
        const { requires_changes, justification } = this.amendment
  
        formData.append('amendment', this.amendment.id)
        formData.append('type', this.amendment.type.key)
        formData.append('justification', justification)
        formData.append('requires_changes', requires_changes)
        formData.append('file', this.file)
        
        const response = await this.saveProtocolAmendment(formData)
        
        this.saving = false
        
        
        const { error, status, message } = response.data.data
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        // Update updated flag.
        this.amendment.updated = true
        
        AlertManager.success(message)
      },
      async saveAttachments(files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('amendment', this.amendment.id)
        formData.append('type', this.amendment.type.key)
        
        const response = await this.saveAmendmentAttachments(formData)
        
        const { status, error, message } = response.data.data
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        $(`#attachments-modal`).modal('hide')
      },
      async deleteAttachment(file, callback) {
        const response = await this.removeAttachmentFromAmendment({
          amendment: this.amendment,
          file,
        })
        
        if(response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        callback(response)
      },
      async deleteAmendment() {
        this.saving = true
        
        const response = await this.deleteProtocolAmendment({
          amendment: this.amendment,
        })
        
        this.saving = false
        
        const { status, error, message } = response.data.data
        
        if(status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
      async sendAmendmentToEvaluation() {
        const response = await this.sendAmendment({
          amendment: this.amendment,
          committee: this.committee,
        })
        
        if(response.data.data.status === 'success') {
          return location.href = `/redirect?url=${encodeURIComponent(location.origin)}&message=${encodeURIComponent(response.data.data.message)}`
        }
        
        AlertManager.error(response.data.data.error)
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      }
    },
    computed: {
      ...mapGetters({
        selectedAmendment: 'amendments/selectedAmendment',
      }),
    },
    mounted() {
      const vm = this

      this.setAmendment(this.amendment)
  
      if(this.readonly) {
        $('#amendment-data', this.$el).find('input, :radio, :checkbox, textarea, button').prop('disabled', true)
      }
      
      // Show dialog.
      this.$nextTick(() => {
        if(this.amendment && this.amendment.requires_changes === null) {
          $('#amendment-require-changes-modal').modal()
        }
      })
      
      autosize(document.getElementById('justification'))
      
      $(this.$refs.form).validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(error, element) {
          error.addClass('invalid-feedback')
          
          if(element[0].type.toLowerCase() === 'radio') {
            element.parents('.form-group').find('.error-bag').html(error)
          }
          else {
            error.insertAfter(element)
          }
        },
        rules: {
          requires_changes: {
            required: true,
          },
          justification: {
            required: true,
          },
          protocol_file: {
            required: () => (this.requiresChanges || this.amendment.requires_changes) && !this.amendment.file_path,
            extension: 'pdf',
            maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
          },
        },
        messages: {
          requires_changes: {
            required: 'Seleccione una opción',
          },
          justification: {
            required: 'Escriba la justificación.',
          },
          protocol_file: {
            required: 'Seleccione el archivo del protocolo.',
            extension: 'El formato del archivo debe ser PDF.',
            maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
          },
        },
      })
    },
    watch: {
      requiresChanges(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.amendment.requires_changes = newVal
        }
      },
    },
  }
</script>
